<ng-container *transloco="let t">
    <button (click)="onClick()" class="logo-button button-undecorated" [ngClass]="{'full-width': hasFullWidth()}"
        role="button">
        <img [src]='logoInfo().logo || src()' id="store-logo" [ngClass]="{'align-center': alignCenter()}"
            [alt]="logoInfo().altText || displayedAltText()" (load)='onLoad()' />
    </button>
</ng-container>